import { render } from "./ToDo.vue?vue&type=template&id=46668905&scoped=true"
import script from "./ToDo.vue?vue&type=script&lang=js"
export * from "./ToDo.vue?vue&type=script&lang=js"

import "./ToDo.vue?vue&type=style&index=0&id=46668905&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46668905"]])

export default __exports__